export const inflect = (input: number, ...plurals: string[]): string => {
  if (input === 1) {
    return plurals[0];
  }

  return plurals.length > 1 ? plurals[1] : `${plurals[0]}s`;
};
